import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import DataTableHelper from "../../../helpers/tables/DataTableHelper";
import Columns from "./Columns";
import {
  getRouteConfigs,
  resourcesGeofence,
  resourcesReports,
  resourcesUnits,
} from "../../../helpers/backend_helper";
import { Container, Button, Spinner } from "reactstrap";
import Select from "react-select";

import dayjs from "dayjs";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ConfigModal from "./ConfigModal";
import ButtonHelper from "../../../helpers/ButtonHelper";
import PreviewPDF from "../../../helpers/previewPDF";

const initFilters = {
  geofences: [],
  startDate: dayjs().startOf("day"),
  endDate: dayjs().endOf("day"),
};

const BaseArrivedReport = () => {
  const [reportConfig, setReportConfig] = useState({});
  const [isLoadingConfigs, setIsLoadingConfigs] = useState(true);
  const [pending, setPending] = useState(false);
  const [modal, setModal] = useState({ show: false, update: false, config: false });
  const [dataPag, setDataPag] = useState({ total: 0 });
  const [items, setItems] = useState([]);
  const [units, setUnits] = useState([]);
  const [geofences, setGeofences] = useState([]);
  const [groupedGeofences, setGroupedGeofences] = useState([]);
  const [filters, setFilters] = useState(initFilters);

  const fetchConfig = useCallback(async () => {
    setIsLoadingConfigs(true);
    try {
      let params = { params: { select: 1 } };

      const configs = await getRouteConfigs();
      const geofences = await resourcesGeofence("get", params);

      const startHourConf =
        configs.find((e) => e.configuration_id == 19)?.value || null;
      const endHourConf =
        configs.find((e) => e.configuration_id == 20)?.value || null;
      const geofencesConf =
        configs.find((e) => e.configuration_id == 21)?.value?.split(",") ||
        null;

      const geofencesFiltered = geofencesConf
        ? geofences.data.filter((geo) =>
            geofencesConf.includes(geo.numero + "")
          )
        : [];

      const today = dayjs().format("YYYY-MM-DD");

      setFilters({
        startDate: startHourConf
          ? dayjs(`${today} ${startHourConf}`, "YYYY-MM-DD HH:mm")
          : initFilters.startDate,
        endDate: endHourConf
          ? dayjs(`${today} ${endHourConf}`, "YYYY-MM-DD HH:mm")
          : initFilters.endDate,
        geofences: geofencesFiltered,
      });

      setReportConfig({
        startDate: startHourConf,
        endDate: endHourConf,
        geofences: geofencesFiltered,
      });

      setGeofences(geofences.data);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingConfigs(false);
    }
  }, []);

  const completeHandler = () => {
    setModal((prev) => ({ ...prev, show: false }));
    fetchConfig();
  };

  const fetchArrivedReport = useCallback(async (filters, isLocal = true) => {
    const config = {
      params: {
        geofences: filters.geofences.map((option) => option.numero).join(","),
        startDate: filters.startDate.format("YYYY-MM-DD HH:mm"),
        endDate: filters.endDate.format("YYYY-MM-DD HH:mm"),
      },
    };
    setPending(true);
    const response = await resourcesReports(
      "show",
      config,
      isLocal ? "arrivedBaseLocalReport" : "arrivedBaseReport"
    );

    //setItems(response.data);
    setGroupedGeofences(response.groupedGeofences);
    setPending(false);
  }, []);

  const checkRemoteData = async () => {
    await fetchArrivedReport(filters, false);
    await fetchArrivedReport(filters);
  };

  useEffect(() => {
    if (filters.startDate && filters.geofences.length) {
      fetchArrivedReport(filters);
    }
  }, [filters, fetchArrivedReport]);

  useEffect(() => {
    let params = { params: {} };
    resourcesUnits("get", params).then((units) => {
      console.log(units.data);
      setUnits(units.data);
    });
  }, []);

  useEffect(() => {
    fetchConfig();
  }, [fetchConfig]);

  const getReports = (type) => {
    
    let config = {
      params: {
        geofences: filters.geofences.map((option) => option.numero).join(","),
        startDate: filters.startDate.format("YYYY-MM-DD HH:mm"),
        endDate: filters.endDate.format("YYYY-MM-DD HH:mm"),
      },
      headers: {
        Accept:
          type == 2
            ? "application/pdf"
            : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      responseType: "blob",
    };


    resourcesReports("show", config, "arrivedBaseLocalReport").then((response) => {
      if (type == 1) {
        console.log(response);
        const url = URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Reporte Ingreso por unidad.xlsx");
        document.body.appendChild(link);
        link.click();
      } else {
        let nombre = "Archivo";
        var reader = new FileReader();
        reader.readAsDataURL(response);
        reader.fileName = nombre[1] || nombre[0];
        reader.onloadend = function (name) {
          name = nombre[0];
          var base64data = reader.result;
          setModal({ show: true, update: false, url: base64data });
        };
      }
    });
  };

  const columns = Columns();
  document.title = "Reporte de enroladas";

  if (isLoadingConfigs)
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <div className="text-center py-4">
              <p>Cargando configuraciones</p>
              <Spinner />
            </div>
          </Container>
        </div>
      </React.Fragment>
    );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="col-12">
            <DataTableHelper
              tittle="Reporte de enroladas"
              filterInp={false}
              columns={[]}
              items={[]}
              pending={pending}
              config={dataPag}
              filters={filters}
              setFilters={setFilters}
              pagination={false}
              showTable={false}
            >
              <div className="mb-3">
                <Button
                  className="btn-sm float-end me-2"
                  type="button"
                  value={"Config"}
                  onClick={(e) => setModal({ ...modal, config: true })}
                >
                  <i className="fa fa-cogs"></i> Configurar
                </Button>
                <Button
                  className="btn-sm float-end me-2"
                  type="button"
                  value={"Config"}
                  onClick={checkRemoteData}
                >
                  <i className="fa fa-cloud"></i> Consultar remoto
                </Button>
                <ButtonHelper
                  addButon={false}
                  reportButons={true}
                  actionReportButon={getReports}
                />
              </div>
              <div className="col-sm-3">
                <label className="form-label">Fecha/Hora inicio:</label>
                <DatePicker
                  className="form-control"
                  selected={filters.startDate.toDate()}
                  onChange={(date) => {
                    const startDate = dayjs(date);

                    const updatedEndDate = filters.endDate
                      .set("year", startDate.year())
                      .set("month", startDate.month())
                      .set("date", startDate.date());

                    if (startDate.isAfter(updatedEndDate)) {
                      toast.warn(
                        "La fecha inicio debe ser menor a la fecha fin"
                      );
                      return;
                    }

                    setFilters((prev) => ({
                      ...prev,
                      endDate: updatedEndDate,
                      startDate,
                    }));
                  }}
                  showTimeSelect
                  dateFormat="dd-MM-yyyy HH:mm"
                />
              </div>
              <div className="col-sm-3">
                <label className="form-label">Fecha/Hora fin:</label>
                <DatePicker
                  className="form-control"
                  selected={filters.endDate.toDate()}
                  onChange={(date) => {
                    const endDate = dayjs(date);

                    const updatedStartDate = filters.startDate
                      .set("year", endDate.year())
                      .set("month", endDate.month())
                      .set("date", endDate.date());

                    if (endDate.isBefore(updatedStartDate)) {
                      toast.warn(
                        "La fecha fin debe ser mayor a la fecha inicio"
                      );
                      return;
                    }

                    setFilters((prev) => ({
                      ...prev,
                      startDate: updatedStartDate,
                      endDate,
                    }));
                  }}
                  showTimeSelect
                  dateFormat="dd-MM-yyyy HH:mm"
                />
              </div>
              <div className="col-sm-6">
                <label className="form-label">Geocercas:</label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isClearable={true}
                  defaultValue={filters.geofences}
                  name="week"
                  placeholder="Unidades"
                  options={geofences}
                  getOptionLabel={(option) =>
                    `${option.numero} - ${option.name}`
                  }
                  getOptionValue={(option) => `${option.id}`}
                  onChange={(e) => {
                    setFilters({ ...filters, geofences: e });
                  }}
                  isMulti
                />
              </div>
              <div className="col-sm-2 d-none">
                <label className="form-label">Unidad:</label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isClearable={true}
                  /* defaultValue={filters.units} */
                  isSearchable={false}
                  name="week"
                  placeholder="Geocercas"
                  options={units}
                  getOptionLabel={(option) => `${option.number}`}
                  getOptionValue={(option) => `${option.id}`}
                  onChange={(e) => [
                    setFilters({ ...filters, units: e ? e.id : null }),
                  ]}
                  isMulti
                />
              </div>
            </DataTableHelper>
            {pending ? (
              <div className="text-center py-4">
                <Spinner />
              </div>
            ) : (
              groupedGeofences.map(({ geofenceNameKey, data }) => {
                const titleParts = geofenceNameKey.split("_");
                const title = titleParts.length > 0 ? titleParts[1] : "";

                return (
                  <DataTableHelper
                    key={geofenceNameKey}
                    tittle={title}
                    filterInp={false}
                    columns={columns}
                    items={data}
                    pending={pending}
                    config={dataPag}
                    filters={filters}
                    setFilters={setFilters}
                    pagination={false}
                  />
                );
              })
            )}
          </div>
        </Container>
        {modal.config && (
          <ConfigModal
            modal={modal}
            setModal={setModal}
            geofences={geofences}
            reportConfig={reportConfig}
            completeHandler={completeHandler}
          />
        )}
        {modal.show && <PreviewPDF modalPdf={modal} setModalPdf={setModal} />}
      </div>
    </React.Fragment>
  );
};

export default BaseArrivedReport;
